module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“So we’re even.” With that disturbingly cryptic statement, the man’s voice seemed to go a couple of octaves deeper than it had been, sending goosebumps down her arms for all the wrong reasons. He slowly raised his hands, keeping his elbows close in by his sides.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not even going to dignify that with a response, Stalker Boy.” She kept the Firestar aimed at his chest, adrenaline making her peripheral vision narrow until all she could see was him over the sights of her gun. “Just put your weapon on the floor and keep your hands where I can see them, because I will not hesitate to shoot you if you even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("breathe")]), _vm._v(" too hard in my direction.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did you—?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Drop. The. Gun.” She gestured impatiently with her own weapon. “Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He complied, stretching his arm out to drop his Glock as close to her as possible. “Okay, it’s on the floor. I’m not here to hurt you,” he said, never taking those still, gray eyes off her.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whatever. Now the one on your ankle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head. “I don’t have—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Spare me. Your leg drags when you walk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a hiss of breath, he bent over and pushed up the frayed hem of his faded jeans, unstrapping the small .38 from the ankle holster she’d known was there. He casually tossed the gun aside, sending it skittering across the ceramic tiles and through the arched doorway into the formal dining room. Then, raising his palms, he opened his eyes wide with what she was fast beginning to realize was his “trust me” look—which really wasn’t working. “I’m not here to hurt you,” he repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great,” Maggie responded calmly, trying not to think about what was going to happen to her nerves once the adrenaline high wore off. “Then why don’t you sit down in that chair and tell me who the hell you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Billy Corrigan, FBI Computer Crimes Division.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Get")]), _vm._v(" your hand back up where I can see it,” Maggie snapped as Billy’s hand froze on its way to his back pocket. “Back up in the air, there we go.” Making a wide circle around the table, she stopped directly behind the chair nearest the small mission-style phone table. All telephones in the house were programmed to dial 911 at the push of a button, and it couldn’t hurt her to be as near one of them as possible. “I don’t want to see your ID, Billy Corrigan, if that’s really your name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is,” he replied calmly. “But it’s funny. You don’t look like a Mary Smythe.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Says you.” Her gun arm was beginning to grow tired, probably from the months—no, years now—she’d been off active duty. She tightened her grip on the Firestar, hoping he wouldn’t notice that her hands were shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged, the casual gesture belying the intensity of his pale eyes as they skimmed across her face, seemingly memorizing it. “Black hair, nice tan, despite living under constant cloud cover. You look more like a Maria.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So my parents are Honduran. So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In fact, I’d even say you look exactly like a Magdalena. Don’t you think, Maggie Reyes?” he asked softly, pinning her with those other-worldly eyes just as surely as if he’d slammed a hand against her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie gasped, backing into the kitchen counter so suddenly, she felt a burst of pain as the edge jabbed into the small of her back. “How—?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I read all your books,” he said, anticipating her question. “Including the author bio. You were a cop for four years before you turned to crime writing full-time. You’ve written eight true crime books for a major publisher, about half of which have landed on some bestseller list somewhere. You used to have a dog named Andromeda, although I don’t see any evidence of her here. And you like surfing and any other sport connected with water.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie could only stare at him, unsure whether to be impressed or deeply frightened.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“I recognized you from the book jacket photo,” ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Corrigan continued. He hitched one shoulder in a singular shrug. “Nice shot. It does you justice.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before she could react, he reached into his back pocket and pulled out his wallet, tossing it on the table so it landed with a loud smack. It fell open, the large, blue FBI at the top of the ID she’d never gotten a solid glimpse of reassuring her slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll find a business card inside with Fay Parker’s name on it,” he said. “She’s the SAC of the San Francisco field office. Call her. She’ll tell you I’m legit.” Corrigan sat down and leaned back in one of her kitchen chairs, lazily stretching his lean, denim-encased legs out in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("SAC. It took her a few minutes to remember that the acronym meant Special Agent in Charge. Darn, it had been a while since she’d been in the game. Maggie tore her gaze away from the man’s wallet on the table, keeping the gun between them as she tried hard to keep her fear under control. “I don’t understand what you’re doing here. If you’re assigned to the San Francisco office, why would a serial killer who, until now, has stuck to his Louisiana territory, interest you?” She braced her tiring right elbow on the Formica and shot him what she hoped was a skeptical look. “Especially if you’re in Computer Crimes. What’re you going to do if you find him—throw old motherboards at him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Before she could react, he sprang out of the chair and pinned her with his body against the counter. She instinctively raised her hands to protect her face, a whimper escaping her lips before she could quell it. ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She didn’t even notice that the Firestar was no longer in her possession until she heard the magazine clatter to the floor, soon followed by a sharp clink indicating he’d ejected the chambered round as well.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll figure something out,” he said softly, making her all too conscious of just how vulnerable she was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Get out,” Maggie whispered, disgusted with herself. That wouldn’t have happened to her two years ago, when she’d been in the best shape of her life—and most likely able to defend herself against the charms of a too-handsome man with scary reflexes. She swiped her hand at the empty gun he held over their heads, knowing as she did so that it was a futile gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was. Instead, Maggie contented herself with wrapping her hands under his left wrist, which was braced against the counter. With a speed that came from years of training and eighteen months with nothing better to do, she brought the arch of her foot down hard along his shin, ending the move by crunching her weight down on his instep. In the split second where Corrigan slightly lost his balance, Maggie pushed back on his wrist, ducking under his arm and finally pinning it to his back at an awkward angle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You like to play rough, Maggie?” he asked through gritted teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jerk. She pushed the offending limb into an even more impossible position. “Drop my gun. Drop it now, or I’ll break your arm,” she snarled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("He dropped the Firestar, but twisted out of her ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("grasp when her attention was momentarily drawn to the fallen weapon.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay,” he said, backing away from her and holding his hands out so his palms faced her. “Okay. There’s no reason to get upset. I need your help, Maggie. I swear, that’s the honest truth. I never meant to frighten you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right,” she retorted. “So your whole ‘speak softly and flash a big gun’ schtick was meant to be reassuring? Was this before or after you were going to stop impersonating an officer and tell me who you really were?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maggie—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stop using my name so much. You sound like a used car salesman.” She advanced toward him and nearly stepped on the Glock she’d made him discard when he first came into the kitchen. She kicked it savagely across the room, far out of reach of either of them. A strand of black hair fell across her forehead and she blew it back in a huff. “You’re not going to be in my house long enough to establish any sort of rapport with me, so get used to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped backing away. “I’m not lying to you now. I am with the FBI. My badge is right there. You can trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A lot of women trusted Kenneth Bianchi, Paul Bernardo, Ted Bundy. All good-looking, charming men.” Finally next to the kitchen phone again, Maggie snatched the receiver out of its cradle. “Homicidal maniacs, the lot of them.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("“Maggie—” She cut him off with a sharp glare. ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("He cleared his throat and tried again. “I believe you. About the Surgeon coming here.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her finger hovered over the automatic dial button, but his words stopped her cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Elizabeth Borkowski, a detective with the Monterey PD, is married to an old friend of mine from school. She knows about my interest in this case,” he continued, his eyes never leaving hers. “Do you really think the police are going to pay attention to you otherwise, without proof? Liz told me they’d filed your tip.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie dropped the receiver back in its cradle, feeling her entire body slump a bit at his words. She wrapped her arms tightly around her body, as if literally holding herself together while the adrenaline drained away as quickly as it had come.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I noticed the similarities between the New Orleans murders and the Carmel murder.” He closed the gap between them and placed a hand gently on her arm. Comforting, not threatening. A good way to approach the mentally unstable. “And when the cops at the Monterey station mentioned Little Rock, St. Louis and Denver, I plugged in my laptop and pulled up the files,” he said. “I knew you were on to something. But I didn’t expect…” He paused, cleared his throat. “You.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You expected Mary Smythe.” She looked down at where he had touched her. It was just a gesture, she told herself. Just meant to inspire trust now that there was a tenuous connection between them. “The crazy woman on Mermaid Point.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He searched her face, probably trying to ascertain her craziness for himself. “I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It doesn’t matter.” Maggie hitched her shoulder abruptly, shrugging his hand off her, surprised when she missed the warmth of his touch once she was free.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not crazy.” His low voice wrapped around her, making her feel almost safe for the first time in two years. “I don’t know what made those cops think so, but I know your work. You have one of the best research minds out there. I saw you at Quantico.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Where she’d given several guest lectures. She turned to look out the window at the waves, tugging on the end of her braid. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, God, make him stop.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You blew my mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bringing her hand up to her forehead, Maggie pinched the bridge of her nose, trying to harden herself to his words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As if sensing how close she was to her breaking point, he asked, “Case in point, how’d you know I wasn’t James Brentwood? Liz said no one at the station has ever met you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("She took a moment before responding, praying her voice would come out strong and steady, even though she didn’t feel that way. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Detective")]), _vm._v(" James Brentwood is a fidgeter.” He flinched at her emphasis on detective, since he’d answered to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("officer.")]), _vm._v(" She gave him a small smile of sympathy and continued. “On the phone you can hear him clicking pens or drumming his fingers while he talks. You’ve barely moved since ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("you came in. And you didn’t know who Adriana was. I took a chance.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned and met his gaze. He raised a questioning eyebrow at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“James’s girlfriend of five months,” she said. “She’s a friend of mine, which is why I asked specifically for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Damn.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah.” They stared at each other for a long moment, the silence stretching between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why do they—?” He stopped, obviously aware that the question he was about to ask was too familiar, too much of a breach of civility. She finished it for him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Think I’m crazy? Try whisking me out of the house for a wild night on the town. You’ll find out in about two seconds.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tempting offer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She whirled on him, not in the mood to flirt no matter what her sarcastic comment had implied. “Get out,” she said with more venom than she’d meant to deliver. Her vision blurred, and she closed her eyes to stop the sudden tears from spilling out of them. She rubbed a hand against her cheekbone. “I’ve got something in my contact lens,” she lied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maggie—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("She flinched when he took a step toward her, his hand outstretched as if to comfort her. Heaven help her, she was so far beyond comforting. “Get out of my house, Agent Corrigan. You lost any amount of ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("trust I had in you when you brought two weapons into my home and lied to me.”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry,” he said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wrapped her arms around herself and dropped her gaze to the floor, all of her tough-girl pretenses gone. She figured they’d been transparent enough anyway. “Just go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Corrigan grabbed his wallet and pulled a card out of it, pressing the small piece of paper onto the bleached wood of the table. “If anything—” He paused. “If anything happens, if you need anything, call me. My cell phone number is at the bottom.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She snorted in response.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped close, so close, until leaning forward just an inch would have brought their bodies into contact. “I’ll be there,” he said, and she could feel his breath on her cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why is this so important to you?” she asked, focusing her gaze on his elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The almost gentle air he’d had abruptly vanished as tension simmered through his frame. He spun around and stalked away, pausing only to pick up his weapons before he headed for the door. Despite the fact that she knew she shouldn’t, Maggie followed, careful to stand to the side when he wrenched it open. “Remember the Riverwalk?” he asked suddenly, his back to her. “The one he took in broad daylight?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jenna—” she paused, almost choking over the next word as understanding dawned “—Corrigan.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("His head turned so she could see a glimpse of his ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("profile in the blinding ray of light streaming in from the outside. “My sister.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then he vanished behind the door, to a place where she couldn’t follow.")])])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fffd1cca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459237469_ch02.vue
// module id = 87
// module chunks = 0